import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import App from 'modules/App';
import { COLORS } from '../../constants';
const AxisLines = ({ innerWidth, innerHeight })=>{
    const direction = useSelector(App.selectors.direction);
    const sideLinePosition = direction === 'ltr' ? 0 : innerWidth;
    return /*#__PURE__*/ _jsxs("g", {
        children: [
            /*#__PURE__*/ _jsx("line", {
                x1: sideLinePosition,
                y1: 0,
                x2: sideLinePosition,
                y2: innerHeight,
                style: {
                    stroke: COLORS.placeholder,
                    strokeWidth: 1
                }
            }),
            /*#__PURE__*/ _jsx("line", {
                x1: 0,
                y1: innerHeight,
                x2: innerWidth,
                y2: innerHeight,
                style: {
                    stroke: COLORS.placeholder,
                    strokeWidth: 1
                }
            })
        ]
    });
};
export default /*#__PURE__*/ memo(AxisLines);
